/*-----------------------------------------------------------------
- Home
-----------------------------------------------------------------*/
export default {
    title               : 'خانه',
    bestsellers_products: 'محصولات پرفروش',
    see_more            : 'مشاهده بیشتر',
    new_products        : 'محصولات جدید',
    blog                : 'جدیدترین مطالب',
    all_posts           : 'همه‌ی مطالب',
};
